export default "__VITE_ASSET__Dgki6c_$__"